import { message, notification } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import type { GetProp, UploadFile, UploadProps } from 'antd';
import RecibosConfigurarService from "../../../../services/http/services/Recibos/RecibosConfigurarService";
import { IPropsConfigRecibos } from ".";

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

export interface ICreateReceiptConfigDTO {
    id: number;
    municipio: string;
    nome: string;
    cargo: string | null;
    footer: string | null;
    imagemLogo: string | null;
    imagemAssinatura: string | null;
    entityId: number;
    "created_at": string
    "updated_at": string
}

export default function useConfigurarRecibos({ handleHabilitarAbasAposConfig }: IPropsConfigRecibos)  {

    const refForm = useRef<any>(null);
    const refIdEntidade = useRef<string>();
    const refIdConfigRecibo = useRef<number>();
    const refController = useRef(new AbortController());

    const [isLoading, setIsLoading] = useState(false);

    const refImagemCarregadaAssinatura = useRef<any>();
    const [loadingCampoUploadAssinatura, setLoadingCampoUpload] = useState<boolean>(false);
    const [imageUrlAssinatura, setImageUrlAssinatura] = useState<string>();

    const refImagemCarregadaLogo = useRef<any>();
    const [loadingCampoUploadLogo, setLoadingCampoUploadLogo] = useState<boolean>(false);
    const [imageUrlLogo, setImageUrlLogo] = useState<string>();

    const [habilitarEdicao, setHabilitarEdicao] = useState<boolean>();
    const [dadosConfigRecibo, setDadosConfigRecibo] = useState<ICreateReceiptConfigDTO | null>(null);

    const [entity, setEntity] = useState<{
        entity: {
            id: number,
            contractId: number,
            description: string,
            instagramProfile: string,
            logo_dark: string,
            logo_light: string,
            name: string,
            updated_at: string,
            url: string,
        }
    } | null>(null);

    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        return () => {
            refController.current.abort();
        }
    }, []);

    const buscaRecibos = useCallback(() => {

        const requestAsync = async () => {
            try {
                setIsLoading(true);
                let LSEntidade = JSON.parse(localStorage.getItem('@GovfacilGestor:selectedEntity')!) || null;

                const data = await RecibosConfigurarService.getRecibosConfig(LSEntidade.entity.id, refController.current.signal);
                setDadosConfigRecibo(data)

                if (data && data != null) {
                    refForm.current?.setFieldsValue(
                        {
                            "id": data.id,
                            "municipio": data.municipio,
                            "nome": data.nome,
                            "cargo": data.cargo,
                            "footer": data.footer,
                            // "imagemAssinatura": null,
                            // "entityId": 1,
                            // "created_at": "2025-04-08T13:01:48.007Z",
                            // "updated_at": "2025-04-08T13:01:48.007Z"
                        }
                    );

                    if (data.imagemLogo) {
                        setImageUrlLogo(
                            data.imagemLogo
                        );
                    } else {
                        setImageUrlLogo(undefined)
                    }

                    if (data.imagemAssinatura) {
                        setImageUrlAssinatura(
                            data.imagemAssinatura
                        );
                    } else {
                        setImageUrlAssinatura(undefined)
                    }

                    refIdConfigRecibo.current = data.id
                    setHabilitarEdicao(false)

                    // habilitar abas
                    handleHabilitarAbasAposConfig();
                }

                setIsLoading(false);

            } catch (error) {
                setIsLoading(false);
            }
        }

        requestAsync();

    }, []);


    useEffect(() => {

        refController.current = new AbortController();

        let LSEntidade = JSON.parse(localStorage.getItem('@GovfacilGestor:selectedEntity')!) || null;
        setEntity(LSEntidade)

        refIdEntidade.current = LSEntidade?.entity?.id ? Number(LSEntidade.entity.id).toString() : undefined
        // let arrayUrl = window.location.pathname.split("/");
        // VerificaRota(arrayUrl, navigate, true, validacaoPermissao(['import_files']));

        buscaRecibos();

    }, []);

    const clickSubmitForm = useCallback((): void => {
        refForm.current?.validateFields()
            .then((values: any) => {
                setIsLoading(true);

                const formData = new FormData();

                formData.append("municipio", values.municipio);
                formData.append("nome", values.nome);

                if (values?.cargo !== undefined && values.cargo !== null) {
                    formData.append("cargo", values.cargo);
                }

                if (values?.footer !== undefined && values.footer !== null) {
                    formData.append("footer", values.footer);
                }

                if (refIdEntidade.current != undefined) {
                    formData.append("entityId", refIdEntidade.current);
                }

                if (refImagemCarregadaAssinatura.current) {
                    formData.append("imagemAssinatura", refImagemCarregadaAssinatura.current)
                }

                if (refImagemCarregadaLogo.current) {
                    formData.append("imagemLogo", refImagemCarregadaLogo.current)
                }

                if (refIdConfigRecibo.current) {
                    formData.append("id", refIdConfigRecibo.current.toString());

                    const editarModalSubmit = async () => {
                        try {

                            const data = await RecibosConfigurarService.putRecibosConfig(refIdConfigRecibo.current!, formData, refController.current.signal);

                            notification.success({
                                message: 'Sucesso',
                                description:
                                    'Seus dados foram editados com sucesso!',
                            });

                            setIsLoading(false);
                            setHabilitarEdicao(false)
                            buscaRecibos();

                        } catch (error) {
                            setIsLoading(false);
                            notification.error({
                                message: 'Erro',
                                description:
                                    'Não foi possivel salvar, entre em contato com suporte!',
                            });
                        }
                    }
                    editarModalSubmit();
                } else {
                    const salvarDadosModalSubmit = async () => {
                        try {
                            const data = await RecibosConfigurarService.postRecibosConfig(formData, refController.current.signal);

                            notification.success({
                                message: 'Sucesso',
                                description:
                                    'Seus dados foram criados com sucesso!',
                            });

                            setIsLoading(false);
                            setHabilitarEdicao(false)
                            buscaRecibos();
                        } catch (error) {
                            setIsLoading(false);
                            notification.error({
                                message: 'Erro',
                                description:
                                    'Não foi possivel salvar, entre em contato com suporte!',
                            });
                        }
                    }
                    salvarDadosModalSubmit();
                }

            })
            .catch((errorInfo: any) => {

                const fieldWithError = errorInfo.errorFields[0].name[0];
                refForm.current.getFieldInstance(fieldWithError).focus();

                notification.error({
                    message: 'Erro',
                    description:
                        'Preencha os campos obrigatórios!',
                });
            });
    }, [buscaRecibos]);

    const beforeUpload = useCallback((file: FileType) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('Você só pode enviar arquivos JPG/PNG!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('A imagem deve ter menos de 2 MB!');
        }
        return isJpgOrPng && isLt2M;
    }, []);

    const getBase64 = useCallback((img: FileType, callback: (url: string) => void) => {
        try {
            const reader = new FileReader();
            reader.addEventListener('load', () => callback(reader.result as string));
            reader.readAsDataURL(img);
        } catch (er) { }
    }, []);

    const handleChange: UploadProps['onChange'] = useCallback((info: any) => {

        refImagemCarregadaAssinatura.current = info.file.originFileObj

        getBase64(info.file.originFileObj as FileType, (url) => {

            setLoadingCampoUpload(false)
            setImageUrlAssinatura(url);
        });

    }, []);

    const uploadButton = useCallback(() => {
        return (
            <div>
                {loadingCampoUploadAssinatura ? <LoadingOutlined /> : <PlusOutlined />}
                <div style={{ marginTop: 8 }}>Adicionar</div>
            </div>
        )
    }, [loadingCampoUploadAssinatura]);


    const handleChangeLogo: UploadProps['onChange'] = useCallback((info: any) => {

        refImagemCarregadaLogo.current = info.file.originFileObj

        getBase64(info.file.originFileObj as FileType, (url) => {

            setLoadingCampoUploadLogo(false)
            setImageUrlLogo(url);
        });

    }, []);

    const uploadButtonLogo = useCallback(() => {
        return (
            <div>
                {loadingCampoUploadLogo ? <LoadingOutlined /> : <PlusOutlined />}
                <div style={{ marginTop: 8 }}>Adicionar</div>
            </div>
        )
    }, [loadingCampoUploadLogo]);

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return {
        refForm,
        uploadButton,
        handleChange,
        beforeUpload,
        imageUrlAssinatura,
        imageUrlLogo,
        clickSubmitForm,
        isLoading,
        habilitarEdicao,
        dadosConfigRecibo,
        setHabilitarEdicao,
        buscaRecibos,
        isModalOpen,
        showModal,
        handleCancel,
        entity,
        handleChangeLogo,
        uploadButtonLogo
    }
}
